import React from 'react';

interface ScrollableContainerProps {
  children: any;
  className?: string;
}

const ScrollableContainer = ({ children, className }: ScrollableContainerProps) => {
  return <article className={`px-4 h-full w-full overflow-x-hidden overflow-y-auto ${className}`}>{children}</article>;
};

export default ScrollableContainer;
